import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"
import { UserPreferenceManager } from "utils/userPreferenceManager"

export enum CpatQuestionnaireTourStatus {
  initiated = "initiated",
  completed = "completed",
}

class CpatQuestionnaireTourManager {
  initiated(): void {
    // Update storage
    UserPreferenceManager.set(
      BROWSER_STORAGE_KEYS.cpatOnboardingQuestionnaireStatus,
      CpatQuestionnaireTourStatus.initiated
    )
    // Track event
    trackingService.trackEvent(TrackingEvents.cpatOnboardingTourStatus, {
      type: "cpat_questionnaire",
      status: CpatQuestionnaireTourStatus.initiated,
    })
  }

  completed(): void {
    // Update storage
    UserPreferenceManager.set(
      BROWSER_STORAGE_KEYS.cpatOnboardingQuestionnaireStatus,
      CpatQuestionnaireTourStatus.completed
    )

    // Track event
    trackingService.trackEvent(TrackingEvents.cpatOnboardingTourStatus, {
      type: "cpat_questionnaire",
      status: CpatQuestionnaireTourStatus.completed,
    })
  }
}

export const cpatQuestionnaireTourManager = new CpatQuestionnaireTourManager()
